import { API_ERROR_CODE, getTraceId } from '@/shared/api'
import { ENV } from '@/shared/config'
import { useTranslation } from '@/shared/i18n'
import { openUrl } from '@/shared/telegram'
import { StateView } from '@/widgets/state-view'

type AccountBlockedPageProps = {
  /** Отказ `U-003` — его trace-id идёт в код на экране. */
  error: unknown
}

/**
 * «Аккаунт заблокирован» — бэкенд отвечает `403 U-003` на любой запрос
 * `/app/*`: блокировку он проверяет в middleware авторизации, сразу за подписью.
 *
 * Повтор не поможет, поэтому кнопки «Обновить» нет: блокировку снимает только
 * поддержка. Главное действие — написать ей; код и trace-id на экране — чтобы
 * поддержка сразу нашла запрос в логах. Причину экран не называет: её знает
 * поддержка, а пересказ без контекста звучал бы обвинением. Нет ссылки на
 * поддержку (`VITE_SUPPORT_URL` пуст) — экран остаётся информационным.
 *
 * Блокировка — не конфискация: купленные и полученные ваучеры действуют, но
 * экран ваучера с QR заблокированному недоступен (`U-003` на любой `/app/*`).
 * Поэтому текст говорит, что ваучеры в силе, а предъявить их помогает
 * поддержка (решение пользователя, PROJECT.md → «Итерация 1»).
 *
 * Круг нейтральный, иконка alert цветом `tg-hint`: красный — для наших
 * сбоев. Haptic `error` один раз — как у чужого подарка: это тоже
 * отказ в доступе, а не сбой.
 *
 * В макете экрана нет — собран на общем шаблоне отказов; тексты ждут ревью.
 */
export const AccountBlockedPage = ({ error }: AccountBlockedPageProps) => {
  const { t } = useTranslation()
  const traceId = getTraceId(error)
  const code = API_ERROR_CODE.USER_BLOCKED

  return (
    <StateView
      icon="alert"
      title={t('accountBlocked.title')}
      text={t('accountBlocked.text')}
      code={traceId ? `${code} · trace-id · ${traceId}` : code}
      haptic="error"
      mainButton={ENV.SUPPORT_URL ? { text: t('common.support'), onClick: () => openUrl(ENV.SUPPORT_URL) } : null}
    />
  )
}
